export default __webpack_public_path__ + "static/15-779bb4d6e22d0a56e2872c2594bd2620.png";